var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-center py-3 cursor-pointer justify-space-between",
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", [
          _vm._v(
            " " +
              _vm._s(
                _vm.inquiry.updatedAt
                  ? _vm.dateFormat(_vm.inquiry.updatedAt)
                  : ""
              ) +
              " "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-blue ms-2 font-bold" }, [
          _vm._v(_vm._s(_vm.inquiry.title)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-small text-gray" },
        [
          _vm.inquiry.commentCount
            ? [
                _c("v-icon", [_vm._v("comment")]),
                _c("span", { staticClass: "ms-1" }, [
                  _vm._v(_vm._s(_vm.inquiry.commentCount) + " コメント"),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._t("action"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }